import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, InputGroup, InputGroupItem, TextArea } from '@patternfly/react-core';
import { TimesIcon } from '@patternfly/react-icons';
import { useContext, useRef } from 'react';
import { useFieldValue } from '../hooks/field-value';
import { useSuggestions } from '../hooks/suggestions';
import { SchemaContext } from '../providers/SchemaProvider';
import { isDefined } from '../utils';
import { FieldWrapper } from './FieldWrapper';
export const TextAreaField = ({ propName, required, onRemove: onRemoveProps }) => {
    var _a, _b;
    const { schema } = useContext(SchemaContext);
    const { value = '', onChange, disabled } = useFieldValue(propName);
    const lastPropName = propName.split('.').pop();
    const ariaLabel = isDefined(onRemoveProps) ? 'Remove' : `Clear ${lastPropName} field`;
    const rows = Math.max(value.split('\n').length, 2);
    const textAreaRef = useRef(null);
    const onFieldChange = (_event, value) => {
        onChange(value);
    };
    const onRemove = () => {
        if (isDefined(onRemoveProps)) {
            onRemoveProps(propName);
            return;
        }
        onChange(undefined);
    };
    const suggestions = useSuggestions({
        propName,
        schema,
        inputRef: textAreaRef,
        value,
        setValue: onChange,
    });
    const id = `${propName}-popover`;
    return (_jsx(FieldWrapper, { propName: propName, required: required, title: schema.title, type: "string", description: schema.description, defaultValue: (_a = schema.default) === null || _a === void 0 ? void 0 : _a.toString(), children: _jsxs(InputGroup, { children: [_jsxs(InputGroupItem, { isFill: true, children: [_jsx(TextArea, { rows: rows, type: "text", role: "textbox", id: propName, name: propName, placeholder: (_b = schema.default) === null || _b === void 0 ? void 0 : _b.toString(), value: value, onChange: onFieldChange, "aria-describedby": id, isDisabled: disabled, ref: textAreaRef }), suggestions] }), _jsx(InputGroupItem, { children: _jsx(Button, { variant: "plain", "data-testid": `${propName}__clear`, onClick: onRemove, "aria-label": ariaLabel, title: ariaLabel, icon: _jsx(TimesIcon, {}) }) })] }) }));
};
//# sourceMappingURL=TextAreaField.js.map